module.exports = __webpack_public_path__ + "static/media/PSET XD Research Projects.843cfc09.csv";